import { forwardRef } from "react";
import type { EquiplyIconProps, EquiplyIcon } from "../types";

/** Notifications / alertes — cloche duotone */
export const BellIcon: EquiplyIcon = forwardRef<SVGSVGElement, EquiplyIconProps>(
  ({ size = 24, ...props }, ref) => (
    <svg ref={ref} width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      {/* Pastille notif menthe */}
      <circle cx="18" cy="6" r="2.5" fill="var(--equiply-icon-bg)" />
      {/* Corps cloche */}
      <path
        d="M6 16V11a6 6 0 0 1 12 0v5l1.5 2.5H4.5L6 16z"
        stroke="var(--equiply-icon-fg)" strokeWidth="1.5" strokeLinejoin="round"
      />
      {/* Battant */}
      <path
        d="M10 19.5a2 2 0 0 0 4 0"
        stroke="var(--equiply-icon-fg)" strokeWidth="1.5" strokeLinecap="round"
      />
    </svg>
  ),
);
BellIcon.displayName = "BellIcon";
